import React from 'react';

const CouponItem = (props) => {
    let selected = props.id === props.selectedCoupon ? " selected " : "";
    let disabled = props.isAvailable ? " " : " disabled ";

    return <>
        <div className="coupon-wrapper">
            <div className={"coupon-item-wrapper" + selected + disabled + props.couponName} onClick={() => props.isAvailable && props.setSelectedCoupon(props.id)}>
                <div className={"coupons " + props.couponName}>
                    <div className={"coupon-item"}>

                    </div>
                    <div className="coupon-name">{props.couponName}</div>
                    {/* <div className="coupon-icon"></div> */}
                </div>
                <div className={"coupon-item-decoration"} ></div>
            </div>
            <div className="coupon-indicator"></div>
        </div>
    </>;
};

export default CouponItem;